module.exports = __webpack_public_path__ + "images/corners/Double Western.18df8f7d9e2d612ff56d6e099b2e3b72.jpg";